import NoResultsFound from '@/common/components/NoResultsFound/NoResultsFound'

import TotalStats from '../TotalStats/TotalStats'
import * as Styles from './styles'

const MostReturnedProduct = ({
  item,
  count,
  percentage,
  countText,
  percentageText,
  sales,
  salesOrdersDataActivated,
}) => {
  const getTemplateColumns = () => {
    const columns = [count, percentage, salesOrdersDataActivated].filter(column => column === 0 || column)

    return `1fr ${columns.length * 25}%`
  }

  if (!item) {
    return <NoResultsFound />
  }

  return (
    <Styles.ProductContainer templateColumns={getTemplateColumns()}>
      {item}
      <TotalStats
        count={count}
        percentage={percentage}
        countText={countText}
        percentageText={percentageText}
        sales={sales}
        salesOrdersDataActivated={salesOrdersDataActivated}
      />
    </Styles.ProductContainer>
  )
}

export default MostReturnedProduct
